export enum ViewModesEnum {
  All = 1,
  General = 2,
  Address = 3,
  Branding = 4,
  Services = 5,
  Banking = 6
}
